<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-pink">
      <b-container fluid class="mt--7">
        <b-row>
          <b-col>
            <b-card no-body class="border-0"> </b-card>
          </b-col>
        </b-row>
      </b-container>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body class="border-0">
            <div>
              <b-card style="background-color: #ffe6e6">
                <Peritos v-if="picked" :selectOption="selectOption" />
                <Asignacion v-else :selectOption="selectOption" />
                <!-- <br /><br /> -->
              </b-card>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Peritos from "./Peritos.vue";
import Asignacion from "./Asignacion.vue";
export default {
  components: {
    Peritos,
    Asignacion
  },
  data() {
    return {
      picked: true
    };
  },
  methods: {
    selectOption() {
      this.picked = !this.picked;
      console.log("toggoled");
    }
  }
};
</script>

<style></style>
